import { pemetaanWilker } from './pemetaan-wilker'

export const monitoring = {
  pemetaanWilker
}
